module.exports = __webpack_public_path__ + "img/view_first_en.ffc1e055.jpg";